import { useQuery } from '@tanstack/react-query';

import { getServicePackages, getTariffs } from '../../../../../../api';

export const useServicePackages = () => useQuery({ queryKey: ['getServicePackages'], queryFn: getServicePackages });
export const useTariffs = () => useQuery({ queryKey: ['getTariffs'], queryFn: getTariffs });
